import { Control, useWatch, useFormContext } from "react-hook-form";
import { ValuationsFormSchemaType } from "../valuations-form";
import { RadioGroup } from "../../../components/inputs/radio-group";
import { ControlledSelect } from "../../../components/forms/controlled-select";
import { useCallback } from "react";
import { PROPERTY_TYPE_OPTIONS, BEDROOMS_OPTIONS, SELLING_TIMEFRAME_OPTIONS } from "./property-options";

interface OptionalPropertyDetailsProps {
  control: Control<ValuationsFormSchemaType>;
}

export const OptionalPropertyDetails = ({ control }: OptionalPropertyDetailsProps) => {
  const { setValue } = useFormContext<ValuationsFormSchemaType>();
  const provideOptionalDetails = useWatch({
    control,
    name: "provideOptionalDetails",
  });

  const onValueChange = useCallback(
    (value: string) => {
      const shouldProvide = value === "true";
      setValue("provideOptionalDetails", shouldProvide);

      // Clear optional fields when selecting "No"
      if (!shouldProvide) {
        setValue("propertyType", "");
        setValue("bedrooms", "");
        setValue("sellingTimeframe", "");
      }
    },
    [setValue],
  );

  // Map boolean | undefined to RadioGroup's string | undefined value
  const radioValue = provideOptionalDetails === undefined ? undefined : provideOptionalDetails ? "true" : "false";

  return (
    <>
      <RadioGroup
        value={radioValue}
        onValueChange={onValueChange}
        label="Want a more tailored valuation? Share a few extra details. (optional)"
        layout="horizontal"
        options={[
          { value: "true", label: "Yes", id: "optional-info-yes" },
          { value: "false", label: "No", id: "optional-info-no" },
        ]}
      />
      {provideOptionalDetails === true && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-x-4 md:gap-y-4.5">
          <ControlledSelect
            control={control}
            name="propertyType"
            label="Property type"
            defaultText="Select property type"
            options={PROPERTY_TYPE_OPTIONS}
          />
          <ControlledSelect
            control={control}
            name="bedrooms"
            label="Bedrooms"
            defaultText="Select number of bedrooms"
            options={BEDROOMS_OPTIONS}
          />
          <ControlledSelect
            control={control}
            name="sellingTimeframe"
            label="When are you thinking about selling?"
            defaultText="Select timeframe"
            options={SELLING_TIMEFRAME_OPTIONS}
            className="md:col-span-2"
          />
        </div>
      )}
    </>
  );
};
